import {
  EventTypes,
  HandleEventCallback,
  IEntityResponseService,
} from '../../types';
import {getChannelAndScopeKey} from '../functions/getChannelAndScopeKey';
import {getMockSubscriptionsSingleton} from './getMockSubscriptionsSingleton';

export const createMockDataSyncService = <
  TData extends Record<TIdKey, any>,
  TEntityName extends string = any,
  TIdKey extends keyof TData = keyof TData
>(): IEntityResponseService<TData, TEntityName, TIdKey> => {
  return {
    subscribe: (
      _accessToken: string,
      scope: string | number | undefined,
      channelName: TEntityName,
      events: EventTypes[],
      callback: HandleEventCallback<TData, TIdKey>,
    ) => {
      console.log(
        'Subscribing to',
        getChannelAndScopeKey(channelName, scope),
        'for events:',
        events.join(', '),
      );
      const subscriptionsSingleton = getMockSubscriptionsSingleton();
      subscriptionsSingleton[getChannelAndScopeKey(channelName, scope)] = {
        callback,
        events,
      };
    },
    unsubcribe: (
      _accessToken: string,
      scope: string | number | undefined,
      channelName: TEntityName,
    ) => {
      console.log(
        'Unsubscribing from',
        getChannelAndScopeKey(channelName, scope),
      );
      const subscriptionsSingleton = getMockSubscriptionsSingleton();
      delete subscriptionsSingleton[getChannelAndScopeKey(channelName, scope)];
    },
  };
};
